import React from 'react';
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import CommonModalV2, { modalWidth } from "./commonModal/v2";

export const ChangeProduct = ({
  classes,
  open,
  productItems = [],
  productListModalError = false,
  defaultQty,
  quantity,
  selectedProductId,
  currentProduct,
  orgQTYValue,
  QTYValue,
  reasonForChangeValue,
  handler = {
    onProductListChange: () => {},
    onQuantityChange: () => {},
    onReasonForChange: () => {},
    onSubmitProductChange: () => {},
    onToggleModal: () => {}
  }
}) => {
  return (
    <CommonModalV2
      title="Changing Prescribed Product"
      open={open}
      style={{ width: modalWidth.l }}
    >
      <div className={classes.modalBody}>
        <div className={classes.modalContentWrapper}>
          <div className={classes.productSelectWrapper}>
            <div
              id="consult-product-label"
              className={classes.productText}
            >
              Product
            </div>
            <FormControl
              variant="outlined"
              className={classes.productInput}
            >
              <Select
                labelId="customized-select-label"
                id="selectedProduct"
                MenuProps={{
                  classes: {
                    paper: classes.menuItemWidth,
                    list: classes.menuItemList,
                  },
                }}
                classes={{ outlined: classes.productSelectStyle }}
                value={selectedProductId}
                onChange={handler.onProductListChange}
                label={void 0}
              >
                {
                  productItems.map((_, index) => {
                    return (
                      <MenuItem
                        title={_.displayTitle}
                        classes={{ selected: classes.menuItemSelected }}
                        className={classes.menuItemRoot}
                        key={index + _.Value}
                        value={_.Value}
                      >
                        {_.displayTitle}
                      </MenuItem>
                    );
                  })
                }
              </Select>
            </FormControl>
          </div>
          {
            productListModalError && (
              <div className={classes.errorWrapper}>
                {productListModalError}
              </div>
            )
          }
          <div className={classes.qtyWrapper}>
            <div
              id="consult-Quantity-label"
              className={classes.productText}
            >
              Quantity
            </div>
            <FormControl
              variant="outlined"
              className={classes.qtySelect}
            >
              <Select
                labelId="customized-select-label"
                id="qtySelect"
                MenuProps={{
                  classes: {
                    paper: classes.qtyMenuItemWidth,
                    list: classes.menuItemList,
                  },
                }}
                classes={{ outlined: classes.productSelectStyle }}
                value={
                  QTYValue ||
                  defaultQty ||
                  (!quantity.length ? orgQTYValue : quantity)
                }
                onChange={handler.onQuantityChange}
                label={void 0}
              >
                {quantity.length ? (
                  quantity.split(",").map((_, index) => {
                    return (
                      <MenuItem
                        title={_}
                        classes={{ selected: classes.menuItemSelected }}
                        className={classes.menuItemRoot}
                        key={index + _}
                        value={_}
                      >
                        {_}
                      </MenuItem>
                    );
                  })
                ) : (
                  <MenuItem
                    title={orgQTYValue}
                    classes={{ selected: classes.menuItemSelected }}
                    className={classes.menuItemRoot}
                    key={orgQTYValue}
                    value={orgQTYValue}
                  >
                    {orgQTYValue}
                  </MenuItem>
                )}
              </Select>
            </FormControl>
          </div>
          <div className={classes.reasonForChangeWrapper}>
            <div
              id="consult-reasonForChangelable"
              className={`${classes.productText} ${classes.reasonForChangeText}`}
            >
              Reason for Change
            </div>
            <textarea
              id="reasonForChangeTextArea"
              maxLength={4000}
              value={reasonForChangeValue}
              onChange={handler.onReasonForChange}
              className={classes.reasonForChangeTextArea}
            />
          </div>
          <div className={classes.modalActionWrapper}>
            <Button
              id="changeProductButton"
              onClick={handler.onSubmitProductChange}
              disabled={
                (currentProduct ===
                  selectedProductId &&
                  QTYValue === orgQTYValue) ||
                !reasonForChangeValue.trim()
              }
              variant="contained"
              color="primary"
              className={classes.buttonStyle}
            >
              Change Product
            </Button>
            <Button
              id="cancelProductButton"
              onClick={() => handler.onToggleModal(false)}
              variant="contained"
              color="primary"
              className={classes.cancelButtonStyle}
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </CommonModalV2>
  );
};

export default ChangeProduct;
